import { render, staticRenderFns } from "./GlobalSearchFilteredElement.vue?vue&type=template&id=3d040a0f&"
import script from "./GlobalSearchFilteredElement.vue?vue&type=script&lang=ts&"
export * from "./GlobalSearchFilteredElement.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports